function makeMatrix(data, home_lineup, away_lineup) {
  var playerRoles = {};
  const playerIds = /* @__PURE__ */ new Set();
  for (const eventId in data) {
    const event = data[eventId];
    if (home_lineup[event.from] == void 0)
      playerRoles[event.from] = (home_lineup[event.from] ?? {}).role || (away_lineup[event.from] ?? {}).role;
    playerRoles[event.to] = (home_lineup[event.to] ?? {}).role || (away_lineup[event.to] ?? {}).role;
    playerIds.add(event.from);
    playerIds.add(event.to);
  }
  const playerArray = Array.from(playerIds);
  const matrix = Array.from(
    { length: playerIds.size },
    () => Array(playerIds.size).fill(0)
  );
  for (const eventId in data) {
    const event = data[eventId];
    const fromIndex = playerArray.indexOf(event.from);
    const toIndex = playerArray.indexOf(event.to);
    matrix[fromIndex][toIndex]++;
  }
  return [matrix, Array.from(playerIds), playerRoles];
}
function calculateTotals(matrix) {
  const rowCount = matrix?.length ?? 0;
  const colCount = matrix[0]?.length ?? 0;
  const rowTotals = new Array(rowCount).fill(0);
  const colTotals = new Array(colCount).fill(0);
  for (let i = 0; i < rowCount; i++) {
    for (let j = 0; j < colCount; j++) {
      rowTotals[i] += matrix[i][j];
      colTotals[j] += matrix[i][j];
    }
  }
  return { rowTotals, colTotals };
}
const colors = {
  goalkeeper: "#440154ff",
  defender: "#31668dff",
  midfielder: "#37b578ff",
  // forward: "#fde725ff",
  forward: "#E48101"
};
const orderRole = {
  undefined: 99,
  goalkeeper: 0,
  defender: 1,
  midfielder: 2,
  forward: 3
};
function sortMatrix(matrix, rowTotals, colTotals, colNames, rowNames, playerRoles) {
  const rowCount = matrix?.length ?? 0;
  const colCount = matrix[0]?.length ?? 0;
  const colIndices = Array.from({ length: colCount }, (_, i) => i);
  colIndices.sort(
    (a, b) => playerRoles[colNames[b]] == playerRoles[colNames[a]] ? colTotals[b] - colTotals[a] : orderRole[playerRoles[colNames[a]]] - orderRole[playerRoles[colNames[b]]]
  );
  const sortedMatrix = [];
  for (let i = 0; i < rowCount; i++) {
    const newRow = colIndices.map((colIndex) => matrix[i][colIndex]);
    sortedMatrix.push(newRow);
  }
  const rowIndices = colIndices;
  const finalMatrix = [];
  for (let i = 0; i < rowCount; i++) {
    finalMatrix.push(sortedMatrix[rowIndices[i]]);
  }
  return {
    newmatrix: finalMatrix,
    newcolNames: colNames.map((v, i, l) => colNames[colIndices[i]]),
    newrowNames: rowNames.map((v, i, l) => rowNames[rowIndices[i]])
  };
}
const passMatrixBuild = (data, team) => {
  const dt = makeMatrix(
    Object.values(data.events ?? {}).filter(
      (v, i, l) => (v.type = "pass") && v.fromTeam == v.toTeam && v.toTeam == team
      // "home"
    ),
    (team == "home" ? data.home_lineup : data.away_lineup) ?? {},
    (team == "home" ? data.away_lineup : data.home_lineup) ?? {}
  );
  const matrix = dt[0];
  const colNames = Array.from(dt[1]);
  const rowNames = Array.from(dt[1]);
  const playerRoles = dt[2];
  const { rowTotals, colTotals } = calculateTotals(matrix);
  let { newmatrix, newcolNames, newrowNames } = sortMatrix(
    matrix,
    rowTotals,
    colTotals,
    colNames,
    rowNames,
    playerRoles
  );
  colNames.sort(
    (a, b) => colTotals[colNames.indexOf(b)] - colTotals[colNames.indexOf(a)]
  );
  rowNames.sort(
    (a, b) => rowTotals[rowNames.indexOf(b)] - rowTotals[rowNames.indexOf(a)]
  );
  return {
    passes: newmatrix,
    // lineup: colNames,
    lineup: newcolNames,
    // rowNames: rowNames,
    rowNames: newrowNames,
    colNames: newcolNames,
    playerRoles
  };
};
export {
  colors as c,
  passMatrixBuild as p
};
